<template>
  <b-container fluid>
    <b-row>
      <b-col cols="12">
        <label>
          {{ tableLabel }}
        </label>
      </b-col>
    </b-row>
    <b-col cols="12" class="variables-and-reference__asset-header" >
      <b-form-checkbox
        v-model="selectAll"
      />
      <span class="variables-and-reference__asset-name">
        {{ tableHeader }}
      </span>
    </b-col>
    <b-container fluid class="variables-and-reference__grid-list">
      <b-row
        :key="item.id"
        v-for="(item, index) in items"
        :class="variableItemClass(index)"
        class="variables-and-reference__asset-item"
      >
        <b-form-checkbox
          v-model="selectedItems"
          @input="updateSelected(selectedItems)"
          :value="item.id"
        />
        {{ item.name }}
      </b-row>
    </b-container>
  </b-container>
</template>

<script>
export default {
  name: 'VariablesAndReferenceGrid',
  props: {
    tableHeader: {
      type: String,
      required: true,
    },
    tableLabel: {
      type: String,
      required: true,
    },
    items: {
      type: Array,
      required: true,
    },
    backup: {
      type: Array,
      required: true,
    },
  },
  data: () => ({
    selectedItems: [],
  }),
  computed: {
    hasAllSelected() {
      return this.selectedItems.length === this.items.length;
    },
    selectAll: {
      get() {
        return this.hasAllSelected;
      },
      set(value) {
        if (!value) {
          this.unselectHandler();
          return;
        }
        this.selectAllHandler();
      },
    },
  },
  methods: {
    unselectHandler() {
      if (this.selectedItems.length === (this.items.length - 1)) return;
      this.clearSelection();
    },
    updateSelected(value) {
      this.$emit('input', value);
    },
    variableItemClass(variableIndex) {
      const baseClass = 'variables-and-reference__asset-item';
      return variableIndex % 2 ? `${baseClass}-pair` : `${baseClass}-odd`;
    },
    selectAllHandler() {
      this.selectedItems = this.items.map(({ id }) => id);
    },
    clearSelection() {
      this.selectedItems = [];
    },
    handleBackup() {
      this.selectedItems = this.backup;
    },
  },
  created() {
    this.handleBackup();
  },
};
</script>

<style lang="sass" scoped>
.variables-and-reference
  &__asset-name
    color: var(--font-color-primary) !important
  &__grid-list
    overflow-y: auto
    max-height: 45vh
  &__asset-item
    min-width: 600px
    height: 35px
    display: flex
    align-items: center
    padding-left: 10px
    &-pair
      background-color: var(--color-table-body-accent-bg)
    &-odd
      background-color: var(--color-background-light)
  &__asset-header
    font-weight: bold
    height: 45px
    background-color: var(--color-table-header-bg)
    color: var(--font-color-primary) !important
    display: flex
    align-items: center
    padding-left: 10px
</style>
